var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g, _g2, _g3, _g4, _path13, _g5, _path14, _g6, _path15, _g7, _path16, _g8, _path17, _g9, _path18, _path19, _g10, _path20, _path21, _g11, _path22, _g12, _path23, _g13, _path24, _path25, _g14, _path26, _path27, _g15, _g16, _path28, _path29, _g17, _path30, _g18, _path31, _g19, _path32, _g20, _g21, _path33, _g22, _path34, _g23, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCurrencyGraph(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 910,
    height: 915,
    viewBox: "0 0 910 915",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M196.106 801.863C308.624 520.568 242.978 223.752 196.114 110.593L199.106 109.354C246.178 223.016 312.041 520.745 199.113 803.066L196.106 801.863Z",
    fill: "url(#paint0_linear_213_13222)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M398.782 884.649C471.596 493.101 429.104 166.287 398.808 51.965L401.939 51.1355C432.358 165.926 474.867 493.226 401.966 885.241L398.782 884.649Z",
    fill: "url(#paint1_linear_213_13222)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.11 436.948C338.797 291.626 306.865 153.604 280.267 70.9478L283.35 69.9558C310.019 152.833 342.01 291.12 351.341 436.741C360.67 582.314 347.374 735.492 283.215 847.944L280.402 846.339C344.087 734.719 357.425 582.319 348.11 436.948Z",
    fill: "url(#paint2_linear_213_13222)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.391 719.059C285.445 484.755 190.308 272.162 122.506 195.243L124.935 193.102C193.454 270.833 289.168 485.075 125.049 720.909L122.391 719.059Z",
    fill: "url(#paint3_linear_213_13222)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.568 422.062C126.709 365.911 96.3172 319.122 71.0132 293.25L73.3284 290.985C99.0019 317.236 129.783 364.613 138.766 421.557C147.764 478.592 134.871 545.116 73.3407 609.412L71.001 607.173C131.816 543.624 144.412 478.122 135.568 422.062Z",
    fill: "url(#paint4_linear_213_13222)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.1138 507.179C77.5753 500.866 99.6639 474.678 99.6639 443.332C99.6639 411.985 77.5753 385.797 48.1138 379.484V382.801C75.7724 389.056 96.4255 413.782 96.4255 443.332C96.4255 472.881 75.7724 497.607 48.1138 503.862V507.179Z",
    fill: "url(#paint5_linear_213_13222)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M722.194 801.863C609.676 520.568 675.323 223.752 722.187 110.593L719.195 109.354C672.123 223.016 606.259 520.745 719.187 803.066L722.194 801.863Z",
    fill: "url(#paint6_linear_213_13222)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M519.519 884.649C446.705 493.101 489.197 166.287 519.492 51.965L516.362 51.1355C485.942 165.926 443.434 493.226 516.335 885.241L519.519 884.649Z",
    fill: "url(#paint7_linear_213_13222)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M570.191 436.948C579.503 291.626 611.435 153.604 638.033 70.9479L634.951 69.9559C608.281 152.833 576.29 291.12 566.959 436.741C557.63 582.314 570.926 735.492 635.086 847.944L637.898 846.339C574.214 734.719 560.875 582.319 570.191 436.948Z",
    fill: "url(#paint8_linear_213_13222)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M795.909 719.059C632.855 484.755 727.992 272.162 795.795 195.243L793.365 193.102C724.846 270.834 629.133 485.075 793.251 720.909L795.909 719.059Z",
    fill: "url(#paint9_linear_213_13222)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M782.733 422.062C791.591 365.911 821.983 319.122 847.287 293.25L844.972 290.986C819.298 317.236 788.517 364.613 779.534 421.557C770.536 478.593 783.429 545.116 844.96 609.412L847.299 607.173C786.484 543.624 773.889 478.122 782.733 422.062Z",
    fill: "url(#paint10_linear_213_13222)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M870.187 507.179C840.725 500.866 818.636 474.678 818.636 443.332C818.636 411.985 840.725 385.797 870.187 379.484V382.801C842.528 389.056 821.875 413.782 821.875 443.332C821.875 472.881 842.528 497.607 870.187 503.862V507.179Z",
    fill: "url(#paint11_linear_213_13222)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_213_13222)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M548.327 887.953C543.702 906.503 524.913 917.793 506.361 913.167C487.816 908.542 476.527 889.752 481.153 871.203C485.776 852.651 504.564 841.361 523.111 845.985C541.663 850.61 552.951 869.402 548.326 887.953L548.327 887.953H548.327Z",
    fill: "#F7931A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.046 874.596C530.735 869.988 527.227 867.511 522.43 865.858L523.986 859.616L520.186 858.669L518.671 864.747C517.672 864.498 516.646 864.263 515.627 864.03L517.153 857.913L513.356 856.966L511.798 863.206C510.972 863.018 510.16 862.832 509.372 862.636L509.377 862.616L504.137 861.308L503.126 865.366C503.126 865.366 505.945 866.012 505.885 866.052C507.424 866.436 507.702 867.454 507.656 868.262L505.883 875.373C505.989 875.4 506.127 875.439 506.278 875.5C506.152 875.468 506.017 875.434 505.877 875.4L503.392 885.362C503.204 885.83 502.727 886.531 501.651 886.265C501.689 886.32 498.889 885.576 498.889 885.576L497.003 889.925L501.947 891.158C502.867 891.389 503.769 891.63 504.657 891.857L503.084 898.171L506.88 899.117L508.437 892.871C509.474 893.152 510.48 893.412 511.465 893.657L509.913 899.874L513.713 900.821L515.285 894.519C521.764 895.745 526.636 895.251 528.687 889.39C530.339 884.672 528.605 881.95 525.196 880.175C527.679 879.603 529.549 877.97 530.048 874.596L530.046 874.595L530.046 874.596ZM521.365 886.77C520.19 891.488 512.246 888.937 509.67 888.298L511.757 879.933C514.332 880.576 522.592 881.849 521.365 886.77H521.365ZM522.54 874.527C521.469 878.819 514.856 876.639 512.711 876.104L514.603 868.518C516.748 869.053 523.656 870.051 522.54 874.527H522.54Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_213_13222)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M789.498 746.507C806.553 746.507 820.378 732.682 820.378 715.628C820.378 698.573 806.553 684.748 789.498 684.748C772.444 684.748 758.619 698.573 758.619 715.628C758.619 732.682 772.444 746.507 789.498 746.507Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.498 681C782.65 681 775.955 683.031 770.261 686.836C764.566 690.641 760.128 696.049 757.507 702.376C754.886 708.704 754.201 715.666 755.537 722.383C756.873 729.1 760.171 735.27 765.013 740.113C769.856 744.955 776.026 748.253 782.743 749.589C789.46 750.925 796.422 750.24 802.75 747.619C809.077 744.998 814.485 740.56 818.29 734.865C822.095 729.171 824.126 722.476 824.126 715.628V715.628C824.139 711.093 823.259 706.601 821.536 702.407C819.813 698.213 817.281 694.4 814.084 691.184C810.887 687.969 807.089 685.414 802.905 683.667C798.721 681.92 794.234 681.014 789.7 681H789.498ZM790.085 716.801L786.48 728.959H805.764C805.892 728.954 806.019 728.975 806.139 729.02C806.259 729.064 806.368 729.132 806.462 729.22C806.555 729.307 806.63 729.412 806.683 729.528C806.736 729.644 806.766 729.77 806.77 729.898V730.216L805.093 736.001C805.019 736.275 804.855 736.515 804.626 736.683C804.398 736.85 804.119 736.935 803.836 736.924H774.323L779.27 720.071L773.736 721.748L774.994 717.891L780.527 716.214L787.486 692.571C787.563 692.299 787.728 692.06 787.956 691.893C788.184 691.726 788.461 691.64 788.744 691.648H796.206C796.334 691.644 796.461 691.665 796.581 691.71C796.7 691.754 796.81 691.822 796.904 691.909C796.997 691.997 797.072 692.101 797.125 692.218C797.178 692.334 797.208 692.46 797.212 692.588V692.906L791.343 712.861L796.877 711.184L795.703 715.208L790.085 716.801Z",
    fill: "#345D9D"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_213_13222)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M399.367 914.156C418.491 914.156 433.994 898.653 433.994 879.529C433.994 860.405 418.491 844.902 399.367 844.902C380.243 844.902 364.74 860.405 364.74 879.529C364.74 898.653 380.243 914.156 399.367 914.156Z",
    fill: "#0AC18E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.168 867.902C408.428 863.956 404.429 863.112 399.534 863.929L397.961 857.83L394.252 858.788L395.799 864.87C394.823 865.116 393.821 865.327 392.828 865.608L391.281 859.562L387.572 860.519L389.146 866.619C388.346 866.847 381.658 868.561 381.658 868.561L382.677 872.533C382.677 872.533 385.402 871.769 385.375 871.83C386.887 871.435 387.599 872.191 387.933 872.903L392.257 889.619C392.31 890.102 392.222 890.928 391.185 891.209C391.246 891.244 388.486 891.904 388.486 891.904L388.891 896.535C388.891 896.535 395.517 894.839 396.387 894.619L397.978 900.789L401.687 899.831L400.096 893.617C401.116 893.38 402.109 893.134 403.076 892.879L404.657 899.058L408.366 898.1L406.776 891.939C412.488 890.55 416.522 886.947 415.696 881.436C415.169 878.114 411.539 875.39 408.524 875.082C410.379 873.439 411.319 871.039 410.168 867.902ZM408.384 882.447C409.122 887.905 401.538 888.573 399.033 889.232L396.853 881.067C399.367 880.408 407.136 877.64 408.384 882.447ZM403.814 871.329C404.596 876.181 398.11 876.743 396.018 877.279L394.032 869.871C396.133 869.352 402.223 866.838 403.814 871.329Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_213_13222)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.8023 610.823C98.8023 624.592 87.6401 635.754 73.8708 635.754C60.1014 635.754 48.9392 624.592 48.9392 610.823C48.9392 597.053 60.1014 585.891 73.8708 585.891C87.6401 585.891 98.8023 597.053 98.8023 610.823Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7019 597.63H69.7544V607.384H77.5382V611.468H69.7544V621.221H74.9443C76.2778 621.221 85.892 621.372 85.8771 609.873C85.8622 598.375 76.5524 597.63 74.7019 597.63Z",
    fill: "#C2A633"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8708 574.811C54.7466 574.811 39.2437 590.313 39.2437 609.438C39.2437 628.562 54.7466 644.065 73.8708 644.065C92.995 644.065 108.498 628.562 108.498 609.438C108.498 590.313 92.995 574.811 73.8708 574.811ZM75.2313 628.14H62.6911V611.468H58.2706V607.384H62.6907V590.712H73.4535C75.9997 590.712 92.8641 590.183 92.8641 609.739C92.8641 629.618 75.2316 628.14 75.2316 628.14H75.2313Z",
    fill: "#C2A633"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M159.285 715.628C159.285 734.752 143.782 750.255 124.658 750.255C105.534 750.255 90.031 734.752 90.031 715.628C90.031 696.504 105.534 681 124.658 681C143.782 681 159.285 696.504 159.285 715.628Z",
    fill: "#FF007A"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_213_13222)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.998 701.725C119.45 701.646 119.424 701.619 119.685 701.593C120.18 701.514 121.327 701.619 122.136 701.804C124.013 702.251 125.708 703.41 127.507 705.437L127.977 705.99L128.655 705.885C131.549 705.411 134.522 705.78 136.999 706.938C137.677 707.254 138.746 707.886 138.876 708.044C138.929 708.097 139.007 708.439 139.059 708.781C139.241 710.019 139.163 710.941 138.772 711.652C138.563 712.046 138.563 712.152 138.694 712.494C138.798 712.757 139.111 712.942 139.398 712.942C140.024 712.942 140.676 711.941 140.989 710.546L141.119 709.993L141.354 710.256C142.683 711.757 143.726 713.837 143.883 715.312L143.935 715.706L143.7 715.364C143.309 714.759 142.944 714.364 142.449 714.021C141.562 713.416 140.623 713.231 138.146 713.1C135.904 712.968 134.626 712.784 133.374 712.362C131.236 711.652 130.141 710.73 127.612 707.333C126.49 705.832 125.786 705.016 125.082 704.332C123.544 702.831 122.005 702.041 119.998 701.725Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.424 705.069C139.476 704.068 139.606 703.41 139.893 702.804C139.998 702.567 140.102 702.357 140.128 702.357C140.154 702.357 140.102 702.541 140.024 702.752C139.815 703.331 139.789 704.147 139.919 705.069C140.102 706.254 140.18 706.412 141.432 707.702C142.005 708.307 142.683 709.071 142.944 709.387L143.387 709.966L142.944 709.545C142.396 709.018 141.145 708.018 140.858 707.886C140.675 707.781 140.649 707.781 140.519 707.913C140.415 708.018 140.389 708.176 140.389 708.939C140.363 710.124 140.206 710.862 139.815 711.625C139.606 712.02 139.58 711.941 139.763 711.494C139.893 711.151 139.919 710.993 139.919 709.861C139.919 707.57 139.659 707.017 138.068 706.096C137.677 705.859 136.999 705.516 136.608 705.332C136.19 705.148 135.878 704.99 135.904 704.99C135.956 704.937 137.494 705.385 138.094 705.648C139.007 706.017 139.163 706.043 139.267 706.017C139.346 705.938 139.398 705.727 139.424 705.069Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.067 708.992C119.971 707.465 119.267 705.095 119.424 703.331L119.476 702.778L119.737 702.831C120.206 702.91 121.014 703.226 121.406 703.463C122.449 704.095 122.918 704.963 123.361 707.123C123.492 707.755 123.674 708.492 123.752 708.729C123.883 709.124 124.378 710.045 124.795 710.625C125.082 711.046 124.9 711.257 124.248 711.204C123.257 711.099 121.927 710.177 121.067 708.992Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.094 720.446C132.931 718.34 131.106 716.523 131.106 713.442C131.106 712.994 131.132 712.626 131.132 712.626C131.158 712.626 131.34 712.784 131.575 712.968C132.618 713.811 133.792 714.179 137.051 714.653C138.954 714.943 140.05 715.154 141.041 715.496C144.196 716.549 146.151 718.708 146.621 721.631C146.751 722.474 146.673 724.08 146.464 724.922C146.282 725.581 145.76 726.792 145.63 726.818C145.604 726.818 145.552 726.687 145.552 726.476C145.499 725.37 144.952 724.317 144.039 723.5C142.944 722.553 141.536 721.842 138.094 720.446Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.444 721.315C134.392 720.92 134.261 720.42 134.183 720.209L134.053 719.814L134.287 720.104C134.626 720.499 134.887 720.973 135.122 721.631C135.304 722.131 135.304 722.289 135.304 723.106C135.304 723.895 135.278 724.08 135.122 724.527C134.861 725.238 134.548 725.739 134.026 726.292C133.088 727.266 131.862 727.792 130.115 728.029C129.802 728.056 128.916 728.135 128.133 728.187C126.178 728.293 124.874 728.503 123.701 728.925C123.544 728.977 123.388 729.03 123.362 729.004C123.309 728.951 124.118 728.477 124.77 728.161C125.682 727.713 126.621 727.476 128.681 727.108C129.698 726.95 130.741 726.739 131.002 726.634C133.583 725.818 134.861 723.79 134.444 721.315Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.816 725.554C136.138 724.053 135.982 722.632 136.347 721.289C136.399 721.157 136.451 721.025 136.503 721.025C136.556 721.025 136.712 721.104 136.868 721.21C137.181 721.42 137.833 721.789 139.502 722.711C141.614 723.869 142.814 724.764 143.648 725.791C144.378 726.687 144.822 727.713 145.03 728.977C145.16 729.688 145.082 731.4 144.9 732.111C144.326 734.349 143.022 736.139 141.119 737.166C140.832 737.324 140.597 737.43 140.571 737.43C140.545 737.43 140.649 737.166 140.806 736.85C141.432 735.507 141.51 734.217 141.041 732.769C140.754 731.874 140.154 730.794 138.954 728.977C137.52 726.871 137.181 726.318 136.816 725.554Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.39 733.612C119.319 731.979 121.692 730.82 123.883 730.452C124.821 730.294 126.386 730.347 127.246 730.584C128.628 730.952 129.88 731.742 130.532 732.716C131.158 733.664 131.445 734.481 131.731 736.297C131.836 737.008 131.966 737.746 131.992 737.904C132.201 738.851 132.618 739.589 133.14 739.984C133.948 740.589 135.356 740.616 136.738 740.089C136.973 740.01 137.181 739.931 137.181 739.957C137.233 740.01 136.529 740.484 136.06 740.721C135.408 741.063 134.887 741.169 134.183 741.169C132.931 741.169 131.862 740.51 131.001 739.194C130.819 738.93 130.454 738.167 130.141 737.456C129.228 735.323 128.759 734.691 127.69 733.98C126.751 733.375 125.552 733.243 124.639 733.691C123.439 734.27 123.127 735.823 123.961 736.771C124.3 737.166 124.926 737.482 125.447 737.561C126.412 737.693 127.246 736.929 127.246 735.955C127.246 735.323 127.012 734.954 126.386 734.665C125.552 734.296 124.639 734.717 124.665 735.534C124.665 735.876 124.821 736.087 125.16 736.245C125.369 736.35 125.369 736.35 125.213 736.324C124.456 736.166 124.274 735.218 124.874 734.612C125.604 733.875 127.142 734.191 127.664 735.218C127.872 735.639 127.898 736.482 127.716 737.008C127.273 738.167 126.021 738.772 124.743 738.43C123.883 738.193 123.518 737.956 122.475 736.877C120.649 734.981 119.945 734.612 117.338 734.217L116.842 734.138L117.39 733.612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.672 691.245C109.747 698.697 119.108 710.282 119.578 710.914C119.969 711.441 119.813 711.941 119.161 712.31C118.796 712.52 118.039 712.731 117.674 712.731C117.257 712.731 116.762 712.52 116.423 712.178C116.188 711.941 115.171 710.44 112.876 706.833C111.129 704.068 109.643 701.777 109.617 701.751C109.513 701.698 109.513 701.698 112.694 707.439C114.702 711.046 115.354 712.336 115.354 712.494C115.354 712.836 115.249 713.021 114.832 713.495C114.128 714.285 113.815 715.18 113.58 717.049C113.32 719.13 112.616 720.604 110.608 723.106C109.434 724.58 109.252 724.843 108.965 725.449C108.6 726.186 108.496 726.608 108.444 727.555C108.391 728.556 108.496 729.188 108.782 730.136C109.043 730.978 109.33 731.531 110.034 732.611C110.634 733.559 110.999 734.27 110.999 734.533C110.999 734.744 111.051 734.744 111.99 734.533C114.232 734.007 116.084 733.111 117.101 732.005C117.726 731.321 117.883 730.952 117.883 730.004C117.883 729.399 117.857 729.267 117.7 728.898C117.44 728.319 116.944 727.845 115.875 727.108C114.467 726.134 113.867 725.344 113.711 724.29C113.58 723.395 113.737 722.79 114.519 721.131C115.327 719.419 115.536 718.708 115.666 716.97C115.745 715.864 115.875 715.417 116.188 715.075C116.527 714.706 116.814 714.574 117.622 714.469C118.952 714.285 119.813 713.942 120.49 713.284C121.09 712.731 121.351 712.178 121.377 711.362L121.403 710.756L121.064 710.388C119.839 708.966 102.863 690.113 102.785 690.113C102.759 690.113 103.176 690.613 103.672 691.245ZM111.677 728.688C111.964 728.187 111.807 727.555 111.338 727.239C110.895 726.95 110.217 727.081 110.217 727.476C110.217 727.582 110.269 727.687 110.425 727.74C110.66 727.871 110.686 728.003 110.503 728.293C110.321 728.582 110.321 728.846 110.556 729.03C110.921 729.32 111.416 729.162 111.677 728.688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.24 714.838C121.614 715.022 121.014 715.707 120.832 716.391C120.728 716.812 120.78 717.576 120.962 717.813C121.249 718.182 121.51 718.287 122.24 718.287C123.674 718.287 124.9 717.655 125.03 716.891C125.161 716.259 124.613 715.391 123.857 714.996C123.466 714.785 122.657 714.706 122.24 714.838ZM123.909 716.154C124.118 715.838 124.039 715.496 123.648 715.259C122.944 714.811 121.875 715.18 121.875 715.864C121.875 716.207 122.423 716.575 122.944 716.575C123.283 716.575 123.752 716.365 123.909 716.154Z",
    fill: "white"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M750.254 798.733C750.254 817.857 734.751 833.36 715.627 833.36C696.503 833.36 681 817.857 681 798.733C681 779.609 696.503 764.105 715.627 764.105C734.751 764.105 750.254 779.609 750.254 798.733Z",
    fill: "#F3BA2F"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_213_13222)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M707.558 796.11L715.628 788.04L723.701 796.113L728.397 791.418L715.628 778.649L702.863 791.414L707.558 796.109L707.558 796.11ZM694.852 799.425L699.547 794.729L704.242 799.424L699.547 804.12L694.852 799.425ZM707.558 802.741L715.628 810.811L723.701 802.737L728.399 807.43L728.397 807.433L715.628 820.201L702.863 807.436L702.856 807.43L707.558 802.741L707.558 802.741ZM727.013 799.427L731.709 794.731L736.404 799.427L731.709 804.122L727.013 799.427Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.39 799.423H720.392L715.628 794.658L712.106 798.179L711.702 798.583L710.867 799.418L710.861 799.424L710.867 799.431L715.628 804.192L720.392 799.428L720.395 799.425L720.39 799.423",
    fill: "white"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M233.156 798.733C233.156 817.857 217.653 833.36 198.529 833.36C179.405 833.36 163.902 817.857 163.902 798.733C163.902 779.609 179.405 764.105 198.529 764.105C217.653 764.105 233.156 779.609 233.156 798.733Z",
    fill: "#2A5ADA"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6_213_13222)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198.528 780.632L195.197 782.542L186.12 787.773L182.789 789.682V807.783L186.12 809.693L195.28 814.923L198.611 816.833L201.943 814.923L210.937 809.693L214.268 807.783V789.682L210.937 787.773L201.859 782.542L198.528 780.632ZM189.451 803.964V793.502L198.528 788.271L207.606 793.502V803.964L198.528 809.194L189.451 803.964Z",
    fill: "white"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M657.916 849.519C657.916 868.643 642.413 884.146 623.289 884.146C604.165 884.146 588.662 868.643 588.662 849.519C588.662 830.395 604.165 814.892 623.289 814.892C642.413 814.892 657.916 830.395 657.916 849.519Z",
    fill: "#0033AD"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip7_213_13222)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M614.668 849.384C614.582 850.886 615.73 852.171 617.222 852.258C617.276 852.258 617.329 852.258 617.383 852.258C618.885 852.258 620.098 851.037 620.087 849.524C620.087 848.012 618.875 846.791 617.372 846.802C615.934 846.802 614.743 847.936 614.668 849.384Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.559 848.682C604.076 848.649 603.658 849.027 603.636 849.514C603.615 850 603.98 850.421 604.462 850.443C604.945 850.475 605.353 850.097 605.385 849.611C605.418 849.125 605.042 848.714 604.559 848.682Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.496 833.546C614.925 833.33 615.097 832.789 614.883 832.357C614.668 831.925 614.131 831.752 613.702 831.968C613.273 832.184 613.101 832.714 613.316 833.146C613.53 833.589 614.056 833.773 614.496 833.546C614.496 833.546 614.485 833.546 614.496 833.546Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.243 838.375C617.909 838.04 618.177 837.219 617.844 836.549C617.512 835.879 616.696 835.609 616.031 835.944C615.365 836.279 615.097 837.1 615.43 837.77C615.762 838.44 616.578 838.71 617.243 838.375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.993 841.692C608.508 842.027 609.195 841.886 609.538 841.368C609.871 840.849 609.731 840.158 609.216 839.812C608.701 839.477 608.014 839.617 607.671 840.136C607.328 840.655 607.478 841.357 607.993 841.692Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.635 848.196C608.884 848.152 608.251 848.725 608.208 849.481C608.165 850.237 608.733 850.875 609.485 850.918C610.236 850.961 610.869 850.389 610.912 849.632C610.955 848.887 610.386 848.239 609.635 848.196Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.143 857.346C607.596 857.627 607.371 858.297 607.65 858.859C607.929 859.41 608.594 859.637 609.152 859.356C609.699 859.075 609.925 858.405 609.646 857.843C609.367 857.292 608.691 857.065 608.143 857.346Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.402 845.376C614.142 845.862 615.129 845.657 615.601 844.911C616.084 844.166 615.88 843.172 615.14 842.696C614.4 842.21 613.412 842.416 612.94 843.161C612.457 843.896 612.661 844.89 613.402 845.376Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.089 838.267C630.711 838.677 631.559 838.505 631.967 837.878C632.375 837.251 632.203 836.398 631.581 835.987C630.958 835.577 630.11 835.75 629.703 836.376C629.284 837.014 629.456 837.856 630.089 838.267Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.858 833.459C633.265 833.729 633.802 833.611 634.07 833.2C634.338 832.789 634.22 832.249 633.813 831.979C633.405 831.709 632.868 831.828 632.6 832.228C632.342 832.638 632.461 833.189 632.858 833.459Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.293 846.78C628.801 846.694 627.513 847.85 627.438 849.352C627.352 850.853 628.501 852.15 629.992 852.225C630.046 852.225 630.099 852.225 630.142 852.225C631.634 852.225 632.847 851.004 632.847 849.492C632.857 848.055 631.731 846.856 630.293 846.78Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.134 845.181C618.595 846.1 619.529 846.683 620.559 846.683C622.051 846.683 623.264 845.462 623.264 843.95C623.264 843.528 623.167 843.107 622.974 842.718C622.298 841.368 620.667 840.827 619.336 841.508C617.995 842.199 617.458 843.842 618.134 845.181Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.371 841.692C639.919 841.411 640.133 840.73 639.854 840.179C639.575 839.628 638.899 839.412 638.352 839.693C637.804 839.974 637.59 840.644 637.858 841.195C638.148 841.746 638.813 841.973 639.371 841.692Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.503 842.556C631.72 842.956 631.398 843.917 631.795 844.706C632.192 845.495 633.147 845.819 633.931 845.419C634.714 845.019 635.036 844.058 634.639 843.269C634.242 842.48 633.287 842.167 632.503 842.556Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.65 833.049C624.262 833.081 624.787 832.606 624.83 831.99C624.873 831.374 624.39 830.845 623.779 830.802C623.167 830.769 622.641 831.234 622.598 831.85C622.566 832.476 623.038 833.006 623.65 833.049Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.639 840.104C624.519 840.158 625.271 839.477 625.313 838.591C625.367 837.705 624.691 836.949 623.811 836.906C622.931 836.852 622.18 837.532 622.137 838.418C622.094 839.304 622.759 840.06 623.639 840.104Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.011 856.482C615.795 856.082 616.116 855.121 615.719 854.332C615.322 853.543 614.367 853.219 613.584 853.619C612.801 854.019 612.479 854.98 612.876 855.769C613.273 856.558 614.228 856.882 615.011 856.482Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.669 842.448C623.854 843.712 624.197 845.397 625.453 846.218C626.708 847.04 628.382 846.694 629.198 845.43C630.014 844.166 629.67 842.48 628.415 841.659C627.975 841.368 627.46 841.216 626.934 841.216C626.022 841.216 625.174 841.681 624.669 842.448Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.381 853.857C628.704 852.506 627.073 851.966 625.743 852.647C624.401 853.327 623.865 854.969 624.541 856.309C625.217 857.66 626.848 858.2 628.179 857.519C629.509 856.849 630.057 855.229 629.391 853.878C629.391 853.867 629.391 853.867 629.381 853.857Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.113 853.662C633.373 853.176 632.385 853.381 631.913 854.127C631.43 854.872 631.634 855.866 632.375 856.341C633.115 856.828 634.102 856.622 634.575 855.877C635.057 855.142 634.854 854.148 634.113 853.662Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.307 849.568C639.35 848.811 638.781 848.174 638.03 848.131C637.279 848.087 636.646 848.66 636.603 849.416C636.56 850.173 637.128 850.81 637.88 850.853C638.62 850.896 639.264 850.313 639.307 849.568Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.052 848.595C642.569 848.563 642.151 848.941 642.129 849.427C642.108 849.913 642.473 850.335 642.956 850.356C643.439 850.389 643.846 850.011 643.879 849.524C643.9 849.038 643.535 848.628 643.052 848.595Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.521 857.346C639.006 857.011 638.32 857.152 637.976 857.67C637.643 858.189 637.783 858.88 638.298 859.226C638.813 859.561 639.5 859.421 639.843 858.902C640.187 858.383 640.037 857.681 639.521 857.346Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.647 865.579C614.239 865.309 613.702 865.427 613.434 865.827C613.166 866.238 613.284 866.778 613.681 867.048C614.088 867.318 614.625 867.199 614.893 866.799C615.172 866.4 615.054 865.849 614.647 865.579Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.019 865.492C632.589 865.708 632.418 866.248 632.632 866.681C632.847 867.113 633.383 867.286 633.813 867.07C634.242 866.853 634.414 866.324 634.199 865.892C633.984 865.449 633.458 865.265 633.019 865.492C633.019 865.492 633.029 865.492 633.019 865.492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.845 856.59C623.661 855.326 623.317 853.641 622.062 852.809C620.806 851.988 619.132 852.333 618.306 853.597C617.479 854.861 617.834 856.547 619.089 857.379C619.529 857.67 620.044 857.822 620.57 857.822C621.493 857.832 622.341 857.368 622.845 856.59Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.426 860.771C616.803 860.36 615.955 860.533 615.548 861.16C615.14 861.787 615.312 862.64 615.934 863.051C616.556 863.461 617.404 863.288 617.812 862.662C618.23 862.035 618.059 861.182 617.426 860.771Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.747 865.989C623.135 865.957 622.609 866.432 622.566 867.048C622.523 867.664 623.006 868.193 623.618 868.236C624.229 868.269 624.755 867.804 624.798 867.188C624.83 866.562 624.358 866.032 623.747 865.989Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.757 858.934C622.877 858.88 622.126 859.561 622.083 860.447C622.03 861.333 622.706 862.089 623.586 862.132C624.466 862.175 625.217 861.506 625.26 860.62C625.313 859.745 624.637 858.978 623.757 858.934Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.271 860.663C629.606 861.009 629.338 861.83 629.681 862.5C630.025 863.169 630.84 863.44 631.506 863.094C632.171 862.759 632.439 861.938 632.106 861.268C631.763 860.598 630.948 860.317 630.271 860.663Z",
    fill: "white"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M872.604 609.438C872.604 628.562 857.101 644.065 837.977 644.065C818.852 644.065 803.349 628.562 803.349 609.438C803.349 590.314 818.852 574.811 837.977 574.811C857.101 574.811 872.604 590.314 872.604 609.438Z",
    fill: "#E6007A"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip8_213_13222)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M838.191 587.913C829.301 587.949 822.104 595.229 822.068 604.221C822.068 606.022 822.355 607.811 822.918 609.518C823.338 610.681 824.584 611.307 825.754 610.948C826.885 610.509 827.485 609.259 827.125 608.089C826.647 606.758 826.434 605.346 826.497 603.932C826.691 597.438 832.053 592.331 838.473 592.527C844.894 592.723 849.942 598.146 849.749 604.641C849.567 610.721 844.833 615.659 838.829 616.028C838.829 616.028 836.565 616.168 835.44 616.307C835.025 616.367 834.613 616.45 834.207 616.555C834.149 616.615 834.056 616.615 833.996 616.556L833.994 616.555C833.954 616.501 833.954 616.426 833.994 616.372L834.345 614.439L836.47 604.77C836.725 603.562 835.965 602.374 834.772 602.116C833.578 601.858 832.403 602.627 832.148 603.834C832.148 603.834 827.093 627.502 827.093 627.717C826.803 628.868 827.49 630.037 828.628 630.33C828.64 630.333 828.654 630.337 828.665 630.338H828.783C829.919 630.636 831.078 629.944 831.371 628.795C831.376 628.777 831.381 628.758 831.384 628.737C831.381 628.701 831.381 628.665 831.384 628.63C831.447 628.352 832.085 625.203 832.085 625.203C832.568 622.826 834.462 621.004 836.832 620.636C837.32 620.56 839.371 620.421 839.371 620.421C848.227 619.528 854.69 611.543 853.806 602.585C853 594.416 846.309 588.126 838.191 587.913Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M839.169 625.516C837.715 625.209 836.294 626.154 835.991 627.622C835.987 627.636 835.986 627.65 835.982 627.664C835.668 629.124 836.583 630.567 838.028 630.885C838.03 630.885 838.031 630.885 838.033 630.887H838.108C839.523 631.233 840.946 630.352 841.286 628.923C841.289 628.912 841.291 628.9 841.294 628.89V628.74C841.544 627.265 840.613 625.849 839.169 625.516Z",
    fill: "white"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M287.636 814.892C268.938 815.388 253.933 830.702 253.933 849.519C253.933 868.337 268.938 883.65 287.636 884.146V814.892Z",
    fill: "#8C8C8C"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M287.635 884.146C306.333 883.65 321.338 868.337 321.338 849.519C321.338 830.701 306.333 815.388 287.635 814.892V884.146Z",
    fill: "#343434"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip9_213_13222)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.951 839.572V839.576L266.249 832.949L270.951 835.727V835.729L270.952 835.727L275.658 832.949L270.952 839.576L270.951 839.572Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M266.255 832.046L271.059 829.924L271.059 829.923L271.059 829.923L271.059 829.923L271.059 829.924L275.64 832.066L275.655 832.057L270.952 824.254L270.951 824.258V824.254L266.255 832.046Z",
    fill: "white"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M876.297 468.621C857.598 469.117 842.593 484.43 842.593 503.248C842.593 522.066 857.598 537.379 876.297 537.875V468.621Z",
    fill: "#3AB83A"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M876.296 537.875C894.994 537.379 909.999 522.065 909.999 503.248C909.999 484.43 894.994 469.117 876.296 468.62V537.875Z",
    fill: "#0B8311"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip10_213_13222)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M859.613 493.301V493.304L854.91 486.677L859.613 489.456V489.457L859.614 489.456L864.32 486.677L859.614 493.304L859.613 493.301Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M854.917 485.774L859.72 483.652L859.72 483.652L859.721 483.652L859.721 483.652L859.721 483.652L864.301 485.795L864.317 485.785L859.614 477.982L859.613 477.986V477.982L854.917 485.774Z",
    fill: "white"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M899.397 421.543C885.874 435.066 863.95 435.066 850.427 421.543C836.904 408.02 836.904 386.095 850.427 372.573C863.95 359.05 885.874 359.05 899.397 372.573C912.92 386.095 912.92 408.02 899.397 421.543Z",
    fill: "url(#paint12_linear_213_13222)"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip11_213_13222)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M858.952 404.827C859.217 404.562 859.581 404.408 859.967 404.408H894.972C895.611 404.408 895.931 405.18 895.479 405.632L888.564 412.547C888.299 412.812 887.935 412.966 887.549 412.966H852.544C851.905 412.966 851.585 412.194 852.037 411.742L858.952 404.827Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M858.948 379.009C859.224 378.744 859.588 378.59 859.963 378.59H894.968C895.607 378.59 895.927 379.362 895.475 379.814L888.56 386.729C888.295 386.994 887.931 387.148 887.545 387.148H852.54C851.901 387.148 851.581 386.376 852.033 385.924L858.948 379.009Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M888.564 391.835C888.299 391.571 887.935 391.416 887.549 391.416H852.544C851.905 391.416 851.585 392.188 852.037 392.64L858.952 399.555C859.217 399.82 859.581 399.975 859.967 399.975H894.972C895.611 399.975 895.931 399.202 895.479 398.75L888.564 391.835Z",
    fill: "white"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M69.254 397.058C69.254 416.182 53.7509 431.685 34.6269 431.685C15.5029 431.685 -0.000244141 416.182 -0.000244141 397.058C-0.000244141 377.934 15.5029 362.431 34.6269 362.431C53.7509 362.431 69.254 377.934 69.254 397.058Z",
    fill: "#FF060A"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip12_213_13222)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.7242 391.803C51.6682 389.905 48.8241 387.006 46.5077 384.95L46.3706 384.854C46.1426 384.671 45.8855 384.527 45.6099 384.429V384.429C40.0245 383.387 14.03 378.528 13.5228 378.59C13.3807 378.61 13.2449 378.661 13.1253 378.741L12.9951 378.843C12.8348 379.006 12.713 379.203 12.6388 379.419L12.6045 379.508V379.995V380.07C15.5308 388.219 27.0855 414.912 29.3608 421.176C29.4979 421.601 29.7583 422.41 30.2449 422.451H30.3545C30.6149 422.451 31.7252 420.984 31.7252 420.984C31.7252 420.984 51.5723 396.916 53.5803 394.352C53.8402 394.037 54.0697 393.697 54.2656 393.338C54.3156 393.057 54.2921 392.768 54.1972 392.499C54.1023 392.23 53.9394 391.99 53.7242 391.803V391.803ZM36.8172 394.606L45.2878 387.581L50.2565 392.159L36.8172 394.606ZM33.5276 394.147L18.9438 382.195L42.5397 386.547L33.5276 394.147ZM34.8434 397.279L49.7699 394.873L32.7052 415.433L34.8434 397.279ZM16.9632 383.387L32.3077 396.408L30.0872 415.447L16.9632 383.387Z",
    fill: "white"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6269 536.836C53.1772 536.836 68.2152 521.798 68.2152 503.248C68.2152 484.697 53.1772 469.659 34.6269 469.659C16.0766 469.659 1.03857 484.697 1.03857 503.248C1.03857 521.798 16.0766 536.836 34.6269 536.836Z",
    fill: "url(#paint13_linear_213_13222)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3262 516.631L37.9685 489.172C37.3279 487.752 36.3756 487.059 35.1204 487.059H34.1162C32.861 487.059 31.9087 487.752 31.2681 489.172L26.3251 501.135H22.5854C21.4687 501.144 20.5597 502.044 20.551 503.17V503.196C20.5597 504.312 21.4687 505.221 22.5854 505.23H24.5938L19.8758 516.631C19.7892 516.882 19.7373 517.142 19.7373 517.41C19.7373 518.051 19.9364 518.553 20.2913 518.942C20.6463 519.332 21.157 519.522 21.7976 519.522C22.2218 519.514 22.6287 519.384 22.9663 519.133C23.3299 518.882 23.5809 518.518 23.78 518.103L28.9741 505.221H32.5753C33.692 505.213 34.601 504.312 34.6097 503.187V503.135C34.601 502.018 33.692 501.109 32.5753 501.101H30.6535L34.6183 491.223L45.422 518.094C45.6211 518.51 45.8721 518.873 46.2357 519.124C46.5733 519.375 46.9889 519.505 47.4044 519.514C48.045 519.514 48.5471 519.323 48.9107 518.934C49.2742 518.544 49.4647 518.042 49.4647 517.401C49.4734 517.142 49.4301 516.873 49.3262 516.631Z",
    fill: "white"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip13_213_13222)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M789.498 226.231C808.623 226.231 824.126 210.728 824.126 191.604C824.126 172.48 808.623 156.976 789.498 156.976C770.374 156.976 754.871 172.48 754.871 191.604C754.871 210.728 770.374 226.231 789.498 226.231Z",
    fill: "#172852"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.763 172.451C786.818 170.935 791.382 170.931 795.513 172.178C800.891 173.847 805.43 177.905 807.802 182.999C808.457 184.45 809.083 185.963 809.146 187.576C806.123 185.824 802.809 184.689 799.488 183.653C794.176 181.738 788.615 180.409 783.587 177.777C782.417 177.077 780.925 176.361 780.606 174.903C780.478 173.642 781.811 172.939 782.763 172.451Z",
    fill: "#FFD83D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.523 184.709C771.697 181.524 773.622 178.567 776.236 176.375C776.901 181.842 779.228 187.126 783.072 191.102C787.681 195.891 794.246 198.83 800.925 198.72C803.578 198.803 806.171 198.19 808.758 197.695C806.213 206.892 796.133 212.996 786.794 211.528C781.157 210.808 775.952 207.47 772.812 202.757C769.269 197.549 768.376 190.634 770.523 184.709Z",
    fill: "#FFD83D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M799.489 183.653C802.809 184.689 806.123 185.825 809.146 187.577L809.35 187.684C809.631 189.793 809.835 191.943 809.461 194.055C807.941 193.411 806.708 192.279 805.42 191.278C802.941 189.215 800.41 186.853 799.489 183.653Z",
    fill: "#FF6F03"
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M399.367 -2.07959e-06C418.491 -1.85154e-06 433.994 15.5031 433.994 34.6271C433.994 53.7512 418.491 69.2543 399.367 69.2543C380.243 69.2543 364.74 53.7512 364.74 34.6271C364.74 15.5031 380.243 -2.30764e-06 399.367 -2.07959e-06Z",
    fill: "url(#paint14_linear_213_13222)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M430.755 34.6271C430.755 17.2916 416.702 3.23843 399.367 3.23843C382.031 3.23843 367.978 17.2916 367.978 34.6271C367.978 51.9626 382.031 66.0158 399.367 66.0158C416.702 66.0158 430.755 51.9626 430.755 34.6271ZM433.994 34.6271C433.994 15.5031 418.491 -1.85154e-06 399.367 -2.07959e-06C380.243 -2.30764e-06 364.74 15.5031 364.74 34.6271C364.74 53.7512 380.243 69.2543 399.367 69.2543C418.491 69.2543 433.994 53.7512 433.994 34.6271Z",
    fill: "url(#paint15_linear_213_13222)"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip14_213_13222)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M411.791 23.0847C409.346 23.0847 406.669 24.4171 403.845 27.0454C402.513 28.28 401.339 29.6247 400.484 30.6882C400.484 30.6882 401.853 32.2652 403.356 33.9643C404.175 32.9375 405.337 31.5439 406.694 30.2848C409.2 27.9377 410.838 27.461 411.779 27.461C415.3 27.461 418.16 30.4193 418.16 34.0744C418.16 37.6928 415.3 40.6511 411.779 40.6878C411.608 40.6878 411.412 40.6633 411.168 40.6144C412.195 41.0912 413.307 41.4334 414.346 41.4334C420.801 41.4334 422.072 36.9715 422.145 36.6537C422.329 35.8347 422.439 34.979 422.439 34.0988C422.426 28.0233 417.659 23.0847 411.791 23.0847Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.237 45.0641C391.682 45.0641 394.359 43.7317 397.183 41.1034C398.516 39.8688 399.689 38.5241 400.545 37.4606C400.545 37.4606 399.176 35.8836 397.672 34.1844C396.853 35.2113 395.692 36.6049 394.335 37.864C391.829 40.1866 390.179 40.6878 389.25 40.6878C385.729 40.6878 382.868 37.7295 382.868 34.0744C382.868 30.456 385.729 27.4977 389.25 27.461C389.421 27.461 389.616 27.4855 389.861 27.5344C388.834 27.0576 387.721 26.7154 386.682 26.7154C380.228 26.7031 378.957 31.165 378.883 31.4951C378.7 32.3141 378.59 33.1698 378.59 34.05C378.59 40.1255 383.357 45.0641 389.237 45.0641Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M394.152 30.3826C393.443 29.698 389.995 26.8987 386.695 26.8009C380.803 26.6542 379.079 30.9327 378.92 31.4828C380.057 26.6908 384.262 23.1091 389.25 23.0847C393.32 23.0847 397.44 27.082 400.484 30.6882L400.496 30.676C400.496 30.676 401.865 32.2529 403.369 33.9521C403.369 33.9521 405.08 35.9691 406.89 37.7417C407.599 38.4262 411.034 41.1889 414.334 41.2867C420.385 41.4579 422.06 36.9349 422.146 36.5926C421.033 41.4212 416.816 45.0152 411.804 45.0396C407.733 45.0396 403.613 41.0423 400.557 37.4361C400.557 37.4483 400.545 37.4483 400.545 37.4605C400.545 37.4605 399.176 35.8836 397.672 34.1844C397.685 34.1844 395.973 32.1551 394.152 30.3826ZM378.92 31.5317C378.92 31.5195 378.92 31.5072 378.932 31.495C378.92 31.5072 378.92 31.5195 378.92 31.5317Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip15_213_13222)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M588.662 34.6271H657.916V103.881H588.662V34.6271Z",
    fill: "#1B1F2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.863 49.5174H634.716V88.9923H611.863V49.5174Z",
    fill: "#1B1F2B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M567.784 49.5174L611.862 5.43909H634.716L678.795 49.5174V88.9923L634.716 133.071H611.862L567.784 88.9923V49.5174Z",
    fill: "url(#paint16_linear_213_13222)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.214 75.4872H625.482V80.4454H621.211V75.4872H616.479V71.2168H630.214V75.4872ZM630.214 63.2518H625.482V58.2936H621.211V63.2518H616.479V67.5222H630.214V63.2518Z",
    fill: "url(#paint17_linear_213_13222)"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M549.416 34.6271C549.416 53.7512 533.913 69.2543 514.789 69.2543C495.665 69.2543 480.162 53.7512 480.162 34.6271C480.162 15.5031 495.665 0 514.789 0C533.913 0 549.416 15.5031 549.416 34.6271Z",
    fill: "#111212"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M514.789 66.0158C532.125 66.0158 546.178 51.9626 546.178 34.6271C546.178 17.2916 532.125 3.23843 514.789 3.23843C497.454 3.23843 483.401 17.2916 483.401 34.6271C483.401 51.9626 497.454 66.0158 514.789 66.0158ZM514.789 69.2543C533.913 69.2543 549.416 53.7512 549.416 34.6271C549.416 15.5031 533.913 0 514.789 0C495.665 0 480.162 15.5031 480.162 34.6271C480.162 53.7512 495.665 69.2543 514.789 69.2543Z",
    fill: "white"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip16_213_13222)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M515.501 11.5422L505.237 25.6655L500.939 46.5433L515.501 55.4033L530.062 46.5433L525.676 25.5778L515.501 11.5422ZM503.307 45.5784L506.553 29.7007L513.922 52.0698L503.307 45.5784ZM507.606 26.1041L515.501 15.2266L523.396 26.1041L515.501 49.9645L507.606 26.1041ZM516.992 52.0698L524.361 29.7007L527.606 45.5784L516.992 52.0698Z",
    fill: "white"
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M750.254 110.807C750.254 129.931 734.751 145.434 715.627 145.434C696.503 145.434 681 129.931 681 110.807C681 91.6828 696.503 76.1797 715.627 76.1797C734.751 76.1797 750.254 91.6828 750.254 110.807Z",
    fill: "white"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip17_213_13222)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M730.212 97.19L724.931 99.8808L699.428 112.871C699.342 112.213 699.298 111.55 699.298 110.887C699.302 108.24 699.996 105.64 701.314 103.345C702.631 101.049 704.526 99.1374 706.809 97.7992C709.093 96.461 711.686 95.7426 714.333 95.7152C716.98 95.6877 719.588 96.3522 721.898 97.6428L724.921 96.1026L725.372 95.8725C722.603 93.8626 719.332 92.6574 715.921 92.3903C712.51 92.1231 709.091 92.8043 706.043 94.3586C702.994 95.913 700.435 98.2798 698.648 101.198C696.861 104.116 695.915 107.471 695.915 110.892C695.915 111.365 695.933 111.836 695.969 112.305C696.019 112.969 695.872 113.633 695.546 114.213C695.219 114.794 694.729 115.265 694.136 115.567L692.542 116.38V120.171L697.235 117.779L698.754 117.003L700.252 116.241L727.137 102.542L730.158 101.003L736.403 97.821V94.0316L730.212 97.19Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M736.403 101.617L701.779 119.246L698.758 120.789L692.542 123.956V127.744L698.715 124.598L703.997 121.908L729.525 108.899C729.612 109.561 729.655 110.228 729.655 110.896C729.654 113.546 728.959 116.149 727.64 118.447C726.321 120.746 724.424 122.659 722.138 123.998C719.851 125.337 717.253 126.054 714.604 126.078C711.954 126.103 709.344 125.434 707.033 124.138L706.847 124.236L703.57 125.907C706.338 127.917 709.609 129.122 713.019 129.39C716.43 129.658 719.849 128.977 722.897 127.424C725.945 125.871 728.505 123.505 730.293 120.588C732.081 117.671 733.028 114.317 733.029 110.896C733.029 110.419 733.01 109.942 732.975 109.471C732.925 108.807 733.072 108.143 733.398 107.563C733.724 106.982 734.214 106.511 734.807 106.208L736.403 105.396V101.617Z",
    fill: "black"
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M198.529 76.1799C217.653 76.1799 233.156 91.683 233.156 110.807C233.156 129.931 217.653 145.434 198.529 145.434C179.404 145.434 163.901 129.931 163.901 110.807C163.901 91.683 179.404 76.1799 198.529 76.1799Z",
    fill: "url(#paint18_linear_213_13222)"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip18_213_13222)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.254 127.82L182.445 97.9951C182.204 97.5192 182.566 96.9561 183.099 96.9561H188.231C188.506 96.9561 188.764 97.1101 188.885 97.3481L199.701 118.985C200.665 120.927 203.454 120.927 204.419 118.985L215.2 97.3652C215.321 97.1272 215.579 96.9732 215.854 96.9732H216.491C216.87 96.9732 217.111 97.3652 216.939 97.6887L201.974 127.82C201.01 129.76 198.219 129.76 197.254 127.82V127.82Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M197.255 127.82L188.885 97.3654C188.764 97.1103 188.489 96.9734 188.266 96.9734H183.117C182.549 96.9734 182.221 97.5349 182.445 98.0125L197.255 127.82Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M199.702 119.001L182.446 97.9951C182.24 97.5021 182.55 97.0074 183.031 96.9561H188.25C188.542 96.9732 188.765 97.1598 188.869 97.3481L199.702 119.001Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_213_13222",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 39,
    y: 256,
    width: 70,
    height: 70
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.2437 256.241H108.498V325.495H39.2437V256.241Z",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_213_13222)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.8708 325.494C54.8259 325.494 39.2437 309.912 39.2437 290.694C39.4168 271.649 54.8259 256.067 74.0439 256.24C93.0889 256.413 108.498 271.822 108.498 291.213C108.325 310.085 92.9157 325.494 73.8708 325.494Z",
    fill: "#0090FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.1606 286.713L76.1218 292.253L85.9905 293.638L85.298 296.235L75.6024 294.85C74.9098 297.101 74.5636 299.525 73.6979 301.602C72.8322 304.026 71.9665 306.45 70.9277 308.701C69.5426 311.644 67.1187 313.722 63.8292 314.241C61.9247 314.588 59.847 314.414 58.2888 313.202C57.7694 312.856 57.25 312.164 57.25 311.644C57.25 310.952 57.5963 310.086 58.1157 309.74C58.462 309.567 59.3276 309.74 59.847 309.913C60.3664 310.432 60.8859 311.125 61.2321 311.817C62.2709 313.202 63.656 313.376 65.0411 312.337C66.5993 310.952 67.465 309.047 67.9844 307.143C69.0232 302.987 70.062 299.005 70.9277 294.85V294.158L61.7515 292.772L62.0978 290.175L71.6203 291.56L72.8322 286.193L62.9635 284.635L63.3098 281.865L73.5248 283.25C73.871 282.211 74.0442 281.345 74.3904 280.48C75.2561 277.363 76.1218 274.247 78.1994 271.477C80.2771 268.707 82.701 266.975 86.3368 267.148C87.895 267.148 89.4532 267.668 90.4921 268.88C90.6652 269.053 91.0115 269.399 91.0115 269.745C91.0115 270.438 91.0115 271.304 90.4921 271.823C89.7995 272.342 88.9338 272.169 88.2413 271.477C87.7219 270.957 87.3756 270.438 86.8562 269.919C85.8174 268.533 84.2592 268.36 83.0472 269.572C82.1815 270.438 81.3159 271.65 80.7965 272.862C79.5845 276.498 78.7188 280.307 77.5069 284.116L87.0293 285.501L86.3368 288.098L77.1606 286.713Z",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip19_213_13222)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M872.595 290.865C872.595 309.986 857.096 325.488 837.973 325.488C818.85 325.488 803.35 309.986 803.35 290.865C803.35 271.743 818.85 256.241 837.973 256.241C857.095 256.241 872.595 271.742 872.595 290.865Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M837.975 256.241C818.859 256.241 803.332 271.765 803.356 290.863C803.361 294.684 803.97 298.36 805.114 301.798H815.472V272.672L837.975 295.174L860.476 272.672V301.799H870.837C871.983 298.361 872.589 294.685 872.596 290.864C872.628 271.746 857.093 256.245 837.975 256.245V256.241Z",
    fill: "#F26822"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832.798 300.347L822.978 290.526V308.854H815.47L808.385 308.855C814.462 318.825 825.445 325.495 837.973 325.495C850.502 325.495 861.485 318.824 867.563 308.854H852.966V290.526L843.145 300.347L837.972 305.52L832.799 300.347H832.798Z",
    fill: "#4D4D4D"
  }))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M323.187 69.2543C323.187 88.3783 307.684 103.881 288.56 103.881C269.436 103.881 253.933 88.3783 253.933 69.2543C253.933 50.1302 269.436 34.6271 288.56 34.6271C307.684 34.6271 323.187 50.1302 323.187 69.2543Z",
    fill: "#8247E5"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip20_213_13222)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M298.598 62.3964C297.799 61.941 296.771 61.941 295.857 62.3964L289.461 66.1535L285.12 68.5443L278.838 72.3014C278.038 72.7568 277.01 72.7568 276.097 72.3014L271.185 69.3413C270.386 68.8859 269.815 67.9751 269.815 66.9504V61.2579C269.815 60.3471 270.271 59.4363 271.185 58.867L276.097 56.0207C276.896 55.5653 277.924 55.5653 278.838 56.0207L283.75 58.9809C284.549 59.4363 285.12 60.3471 285.12 61.3717V65.1288L289.461 62.6241V58.7531C289.461 57.8423 289.004 56.9315 288.09 56.3623L278.952 51.0113C278.153 50.5559 277.125 50.5559 276.211 51.0113L266.845 56.4761C265.931 56.9315 265.474 57.8423 265.474 58.7531V69.4551C265.474 70.3659 265.931 71.2767 266.845 71.846L276.097 77.197C276.896 77.6524 277.924 77.6524 278.838 77.197L285.12 73.5538L289.461 71.049L295.743 67.4058C296.542 66.9504 297.57 66.9504 298.484 67.4058L303.396 70.2521C304.195 70.7075 304.766 71.6183 304.766 72.643V78.3355C304.766 79.2463 304.309 80.1571 303.396 80.7264L298.598 83.5726C297.799 84.028 296.771 84.028 295.857 83.5726L290.946 80.7264C290.146 80.271 289.575 79.3602 289.575 78.3355V74.6923L285.234 77.197V80.9541C285.234 81.8649 285.691 82.7757 286.605 83.3449L295.857 88.6959C296.657 89.1513 297.685 89.1513 298.598 88.6959L307.85 83.3449C308.65 82.8895 309.221 81.9787 309.221 80.9541V70.1382C309.221 69.2274 308.764 68.3166 307.85 67.7474L298.598 62.3964Z",
    fill: "white"
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M159.285 191.604C159.285 210.728 143.782 226.231 124.658 226.231C105.534 226.231 90.031 210.728 90.031 191.604C90.031 172.48 105.534 156.976 124.658 156.976C143.782 156.976 159.285 172.48 159.285 191.604Z",
    fill: "#0089DB"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip21_213_13222)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.888 185.539V188.981L118.791 186.863L115.888 185.539Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.757 168.519C122.511 168.434 103.64 186.111 103.884 190.393C104.129 194.675 122.338 212.464 125.869 212.379C129.401 212.295 147.577 195.313 147.742 190.506C147.906 185.698 129.002 168.604 125.757 168.519ZM124.729 188.848C124.465 189.907 124.069 190.039 123.409 189.907C122.749 189.775 121.298 188.451 121.298 188.451L117.34 192.29V195.731C117.34 197.743 117.955 197.187 118.263 196.658L133.833 181.039C137.21 177.65 137.879 182.274 137.791 185.01V193.878C137.791 199.702 134.976 199.128 133.569 198.114L131.062 195.731C131.062 195.731 127.895 192.819 127.895 192.29C127.895 191.76 128.555 191.495 128.555 191.495C129.215 191.495 129.954 191.972 132.381 194.407C134.809 196.843 135.24 195.422 135.152 194.407V188.186C135.152 184.268 133.569 184.966 132.777 185.804C128.335 190.834 118.923 200.893 116.812 200.893C114.701 200.893 114.085 199.04 114.041 198.114V185.01C114.041 182.574 115.449 182.671 116.152 183.024C116.152 183.024 124.992 187.789 124.729 188.848Z",
    fill: "white"
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M714.829 458.534C714.829 600.886 598.66 716.285 455.359 716.285C312.058 716.285 195.89 600.886 195.89 458.534C195.89 316.182 312.058 200.783 455.359 200.783C598.66 200.783 714.829 316.182 714.829 458.534Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M455.359 703.331C591.587 703.331 701.875 593.65 701.875 458.534C701.875 323.417 591.587 213.737 455.359 213.737C319.131 213.737 208.844 323.417 208.844 458.534C208.844 593.65 319.131 703.331 455.359 703.331ZM455.359 716.285C598.66 716.285 714.829 600.886 714.829 458.534C714.829 316.182 598.66 200.783 455.359 200.783C312.058 200.783 195.89 316.182 195.89 458.534C195.89 600.886 312.058 716.285 455.359 716.285Z",
    fill: "url(#paint19_linear_213_13222)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M381.788 482.98C383.155 482.98 384.446 482.661 385.662 482.023C386.876 481.385 387.941 480.522 388.853 479.433C389.764 478.346 390.485 477.144 391.018 475.83C391.549 474.517 391.815 473.184 391.815 471.833C391.815 469.056 390.77 466.729 388.681 464.851C386.592 462.976 383.725 462.036 380.078 462.036H359.226V482.98H381.788ZM359.226 448.074H378.825C380.421 448.074 381.806 447.773 382.984 447.168C384.161 446.564 385.149 445.771 385.947 444.789C386.744 443.808 387.352 442.694 387.77 441.448C388.187 440.203 388.397 438.976 388.397 437.768C388.397 436.561 388.169 435.391 387.713 434.258C387.257 433.125 386.648 432.143 385.89 431.313C385.13 430.482 384.238 429.804 383.212 429.275C382.186 428.748 381.104 428.482 379.965 428.482H359.226V448.074ZM404.35 437.442C404.35 439.1 404.008 440.868 403.325 442.75C402.641 444.633 401.71 446.366 400.532 447.946C399.354 449.526 397.929 450.863 396.259 451.954C394.588 453.046 392.764 453.63 390.79 453.704C392.841 453.855 394.872 454.436 396.886 455.446C398.898 456.455 400.703 457.823 402.298 459.545C403.894 461.268 405.204 463.252 406.23 465.497C407.255 467.744 407.768 470.14 407.768 472.684C407.768 477.177 407.084 480.975 405.717 484.083C404.35 487.19 402.487 489.699 400.134 491.607C397.778 493.518 395.024 494.884 391.873 495.707C388.719 496.53 385.358 496.942 381.788 496.942H343.274V414.519H379.965C383.307 414.519 386.46 414.84 389.423 415.48C392.385 416.121 394.967 417.287 397.171 418.98C399.374 420.674 401.12 423.009 402.413 425.982C403.704 428.955 404.35 432.777 404.35 437.442Z",
    fill: "url(#paint20_linear_213_13222)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M414.535 498.064H430.246V415.58H414.535V498.064Z",
    fill: "url(#paint21_linear_213_13222)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M498.703 429.553H474.996V498.064H459.117V429.553H435.297V415.58H498.703V429.553Z",
    fill: "url(#paint22_linear_213_13222)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M483.552 498.064L525.964 415.58H527.552L569.964 498.064H552.727L546.263 485.088C539.655 470.955 533.047 456.822 526.438 442.689C517.889 461.147 509.339 479.606 500.79 498.064H483.552Z",
    fill: "url(#paint23_linear_213_13222)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M512.168 488.481L540.785 488.525L526.28 459.908L512.168 488.481Z",
    fill: "url(#paint24_linear_213_13222)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_213_13222",
    x1: 228.73,
    y1: 109.974,
    x2: 228.73,
    y2: 802.464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#33B1E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A5ADA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_213_13222",
    x1: 420.488,
    y1: 51.5503,
    x2: 420.488,
    y2: 884.945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F03F4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0AC18E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_213_13222",
    x1: 317.103,
    y1: 70.4518,
    x2: 317.103,
    y2: 847.141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8247E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_213_13222",
    x1: 168.883,
    y1: 194.172,
    x2: 168.883,
    y2: 719.984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0089DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF007A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_213_13222",
    x1: 105.948,
    y1: 292.118,
    x2: 105.948,
    y2: 608.292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0090FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2A633"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_213_13222",
    x1: 73.8889,
    y1: 379.484,
    x2: 73.8889,
    y2: 507.179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF060A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF56A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_213_13222",
    x1: 689.571,
    y1: 109.974,
    x2: 689.571,
    y2: 802.464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3BA2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_213_13222",
    x1: 497.813,
    y1: 51.5503,
    x2: 497.813,
    y2: 884.945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#616870"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_213_13222",
    x1: 601.197,
    y1: 70.4519,
    x2: 601.197,
    y2: 847.141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2DE0C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0033AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_213_13222",
    x1: 749.418,
    y1: 194.172,
    x2: 749.418,
    y2: 719.984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#172852"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#345D9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_213_13222",
    x1: 812.353,
    y1: 292.118,
    x2: 812.353,
    y2: 608.292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F26822"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6007A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_213_13222",
    x1: 844.411,
    y1: 379.484,
    x2: 844.411,
    y2: 507.179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C836F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34C800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_213_13222",
    x1: 899.397,
    y1: 372.573,
    x2: 850.427,
    y2: 421.543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10F0AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D923FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_213_13222",
    x1: 59.6699,
    y1: 482.176,
    x2: 9.69045,
    y2: 524.228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6509E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2EBAC6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_213_13222",
    x1: 364.74,
    y1: 34.6271,
    x2: 433.994,
    y2: 34.6271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#562785"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#ED1E79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#F15A24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB03B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_213_13222",
    x1: 364.74,
    y1: 34.6271,
    x2: 433.994,
    y2: 34.6271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#562785"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#ED1E79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#F15A24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB03B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_213_13222",
    x1: 542.31,
    y1: 15.3524,
    x2: 641.758,
    y2: 164.757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AB8E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#29CAD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2EE4BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_213_13222",
    x1: 3027.79,
    y1: 3955.01,
    x2: 4667.35,
    y2: 4971.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#29CAD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2EE4BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_213_13222",
    x1: 163.901,
    y1: 110.807,
    x2: 233.156,
    y2: 110.807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB71CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1EBCED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_213_13222",
    x1: 455.359,
    y1: 74.1699,
    x2: 455.359,
    y2: 716.285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#562785"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#ED1E79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#F15A24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB03B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_213_13222",
    x1: 375.521,
    y1: 394.276,
    x2: 375.521,
    y2: 496.942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#562785"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#ED1E79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#F15A24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB03B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_213_13222",
    x1: 422.39,
    y1: 395.321,
    x2: 422.39,
    y2: 498.064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#562785"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#ED1E79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#F15A24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB03B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_213_13222",
    x1: 467,
    y1: 395.321,
    x2: 467,
    y2: 498.064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#562785"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#ED1E79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#F15A24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB03B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_213_13222",
    x1: 526.758,
    y1: 395.321,
    x2: 526.758,
    y2: 498.064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#562785"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#ED1E79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#F15A24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB03B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_213_13222",
    x1: 526.477,
    y1: 452.88,
    x2: 526.477,
    y2: 488.525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#562785"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#ED1E79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#F15A24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB03B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_213_13222"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 69.2543,
    height: 69.2543,
    fill: "white",
    transform: "translate(480.162 844.902)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_213_13222"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 69.2543,
    height: 69.2543,
    fill: "white",
    transform: "translate(754.871 681)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_213_13222"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 69.2543,
    height: 69.2543,
    fill: "white",
    transform: "translate(364.74 844.902)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_213_13222"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 69.2543,
    height: 69.2543,
    fill: "white",
    transform: "translate(39.2437 574.811)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_213_13222"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.8853,
    height: 51.0295,
    fill: "white",
    transform: "translate(102.788 690.113)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_213_13222"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41.5526,
    height: 41.5526,
    fill: "white",
    transform: "translate(694.852 778.649)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_213_13222"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.4792,
    height: 36.2011,
    fill: "white",
    transform: "translate(182.789 780.632)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7_213_13222"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.2424,
    height: 37.4347,
    fill: "white",
    transform: "translate(603.636 830.802)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip8_213_13222"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.8195,
    height: 43.0499,
    fill: "white",
    transform: "translate(822.068 587.913)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip9_213_13222"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49.6188,
    height: 49.6188,
    fill: "white",
    transform: "translate(263.293 824.254)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip10_213_13222"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49.6188,
    height: 49.6188,
    fill: "white",
    transform: "translate(851.955 477.982)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip11_213_13222"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.861,
    height: 34.3764,
    fill: "white",
    transform: "translate(851.827 378.59)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip12_213_13222"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.861,
    height: 43.861,
    fill: "white",
    transform: "translate(11.5422 378.59)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip13_213_13222"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 69.2543,
    height: 69.2543,
    fill: "white",
    transform: "translate(754.871 156.976)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip14_213_13222"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.861,
    height: 21.9794,
    fill: "white",
    transform: "translate(378.59 23.0847)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip15_213_13222"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 588.662,
    y: 34.6271,
    width: 69.2543,
    height: 69.2543,
    rx: 34.6271,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip16_213_13222"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.1237,
    height: 43.861,
    fill: "white",
    transform: "translate(500.939 11.5422)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip17_213_13222"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.861,
    height: 37.1138,
    fill: "white",
    transform: "translate(692.542 92.339)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip18_213_13222"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.6271,
    height: 32.3187,
    fill: "white",
    transform: "translate(182.369 96.9561)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip19_213_13222"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 69.2469,
    height: 69.2543,
    fill: "white",
    transform: "translate(803.349 256.241)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip20_213_13222"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.861,
    height: 38.14,
    fill: "white",
    transform: "translate(265.474 50.7866)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip21_213_13222"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.861,
    height: 43.861,
    fill: "white",
    transform: "translate(103.882 168.519)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrencyGraph);
export default __webpack_public_path__ + "static/media/currency-graph.1f6019d5ad239bdf16b5578676ec3300.svg";
export { ForwardRef as ReactComponent };